import { ActionIcon, CommunicationIcon } from '@tymbe/ui-icons';
import { useQuery } from 'react-query';
import feathersClient from '../../apiClient';
import getResponseArray from '@tymbe/utils/getResponseArray';
import { ContactType } from '@tymbe/schema/enums';
import { useUser } from '../../apiClient/ApiContext';
import classNames from 'classnames';

type ContactInfoProps = {
  className?: string;
}

const getDisplayEmail = (email?: string | null) => {
  if (!email) return undefined;
  const normalized = email.toLowerCase();
  if (normalized.includes('beeflex.cz')) return 'agentura@beeflex.cz';
  if (normalized.includes('@tymbe')) return 'info@tymbe.cz';
  return email;
};

const ContactInfo = ({ className }: ContactInfoProps) => {
  const user = useUser();

  const { data: contactTymbe } = useQuery(['tymbeContact', user.person_id], async () => {
    const resp = await feathersClient.service('branchoffice').find({
      query: {
        $joinRelation: 'person',
        'person.id': user.person_id,
        contact_tymbe: { $null: false },
        $eager: '[contactTymbe.[contact]]',
      },
    });
    const contactTymbe = getResponseArray(resp)?.[0]?.contactTymbe;
    if (!contactTymbe) return null;

    return {
      first_name: contactTymbe?.first_name,
      last_name: contactTymbe?.last_name,
      phone: (contactTymbe?.contact?.find(c => c.type === ContactType.MOBILE_PHONE) ?? contactTymbe?.contact?.find(c => c.type === ContactType.LANDLINE))?.value,
      email: getDisplayEmail(contactTymbe?.contact?.find(c => c.type === ContactType.EMAIL)?.value),
    };
  }, { enabled: !!user.person_id });

  return (
    <div className={classNames('flex flex-col bg-secondary-transparent-5 @[100px]:gap-3 ml-6 shrink-0 align-center text-secondary-600 relative rounded-2xl overflow-hidden', className)} hidden={!contactTymbe}>
      <div className="px-4 pt-3 text-body-2-xl text-secondary-500 flex items-center">
        <div className="grow">Kontaktní osoba:</div>
      </div>
      <div className="flex flex-col bg-gradient-to-b to-secondary-100 from-bg rounded-2xl p-4 gap-3">
        <div className="text-body-1-xl font-semibold flex flex-col">
          <div>{contactTymbe?.first_name} {contactTymbe?.last_name}</div>
        </div>
        <div className="text-body-1-xl flex flex-col text-body-2-xl text-secondary-500">
          <div hidden={!contactTymbe?.phone}><CommunicationIcon name="phone" className="size-4 inline" /> {contactTymbe?.phone}</div>
          <div hidden={!contactTymbe?.email}><CommunicationIcon name="email" className="size-4 inline" /> {contactTymbe?.email}</div>
        </div>
      </div>
    </div>
  )
}

export default ContactInfo;
